import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
const DiscrepancyMasterCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [name, setName] = useState("");
  const [disabledButton, setDisabledButton] = useState(true);

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [resolutionDays, setResolutionDays] = useState('');
  const [customerDependacy, setCustomerDependancy] = useState("false")
  const [customerDependacyData , setCustomerDependancyData] = useState([
    { code: "true", name: "YES" },
    { code: "false", name: "NO" },
  ])
  useEffect(() => {
    (async () => {
      if (params.id) {
        // Get Data from API
        setCallInProgress(true);
        const result = await apiHandler({
          url: endpoint.DISCREPANCY_FINDBYID + params.id,
          authToken: authToken,
        });
        setCallInProgress(false);
        setName(result?.data?.discrepancyName)
        setCustomerDependancy(result?.data?.customerDepencency)
        setResolutionDays(result?.data?.rosolutionETADays)
      }
    })();
  }, []);

  useEffect(()=>{
    if(resolutionDays && name){
        setDisabledButton(false)
    }
  },[name, resolutionDays])

  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const editInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.DISCREPANCY_UPDATE + params?.id, 
      method: "PUT",
      authToken: authToken,
      data: {
        discrepancyName:name?.toUpperCase(),
        rosolutionETADays:resolutionDays,
        customerDepencency:customerDependacy,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description,true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const saveInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.DISCREPANCY_CREATE,
      method: "POST",
      authToken: authToken,
      data: {
        discrepancyName:name?.toUpperCase(),
        rosolutionETADays:resolutionDays,
        customerDepencency:customerDependacy,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description,true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const handleDiscrepancySubmit = async (event) => {
    toastUpdate("", "",false);
      let status = "";
      if (params.id) {
        status = await editInformation();
      } else {
        status = await saveInformation();
      }
      if (status === "SUCCESS") {
        const msg = params.id
          ? "Discrepancy updated successfully!"
          : "Discrepancy created successfully!";
          toastUpdate("Success", msg,true);
        setRedirectURL(`/coreservice/Discrepancy`);
      }
  };
  const handleCancel = () => {
    navigate("/coreservice/Discrepancy");
  };
  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
        setResolutionDays(e);
    }
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={params.id ? "Edit Discrepancy" : "Create Discrepancy"}
          button1=" Save"
          button2=" Cancel"
          button1click={handleDiscrepancySubmit}
          button2click={handleCancel}
          disabled1={disabledButton}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Discrepancy Name"
              required
              id="name"
              value={name || ""}
              setState={setName}
              type="notCapital"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Resolution Days"
              required
              id="days"
              value={resolutionDays || ""}
              setState={handleChange}
              type="notCapital"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomSelectNew
              label="Customer Dependancy*"
              id="dependancy"
              value={customerDependacy}
              setState={setCustomerDependancy}
              data={customerDependacyData}
              type="bool"
            />
          </Grid>
        </Grid>
      </Grid>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default DiscrepancyMasterCreate;
